exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{\r\n    position: relative;\r\n    min-height: 100%;\r\n}\r\n\r\nbody{\r\n    min-height: 100%;\r\n    height: auto !important;\r\n    height: 100%;\r\n    margin:0 0 103px;\r\n    padding-bottom: 5px;\r\n    background-color: #f0f0f0;\r\n}\r\nfooter {\r\n    border-top: 3px solid #002699;\r\n    position: absolute;\r\n    height: 90px;\r\n    bottom: 10px;\r\n    width: 100%;\r\n    background-color: #f0f0f0;\r\n    border-bottom-left-radius: 2em;\r\n    border-bottom-right-radius: 2em;\r\n    text-align: center;\r\n    padding-top: 10px;\r\n\r\n}\r\nfooter > p {\r\n    font-size: 20px;\r\n     color: black;\r\n    font-weight: normal;\r\n}\r\n\r\n@media screen and (max-width:767px){\r\n    body {\r\n        margin: 0 0 93px;\r\n    }\r\nfooter {\r\n    bottom: 0;\r\n    border-radius: 0;\r\n}\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./css/footer.css
// module id = 53
// module chunks = 0